export default __webpack_public_path__ + "static/media/intro_image_2.f9157a1e.jpg";